module.exports = __webpack_public_path__ + "static/media/18.149bcf0d.jfif";